import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
//import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { Auth0Provider } from '@auth0/auth0-react';
import { Auth0BackedProvider, NoAuthProvider } from './context/AuthContext';
// Call the element loader after the platform has been bootstrapped
//defineCustomElements(window);

const isPrivateIP = /^(localhost|10\.|172\.(1[6-9]|2[0-9]|3[01])\.|192\.168\.|100\.(6[4-9]|[7-9][0-9]|1([01][0-9]|2[0-7]))\.)/.test(
  window.location.hostname
);
const useExternalAuth =
  !(window as any).__E2E_NO_AUTH__ && !isPrivateIP;

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    {useExternalAuth ? (
      <Auth0Provider
        domain="dev-s4l4fwvt05o1jmep.eu.auth0.com"
        clientId="vgN35I6xG7uATYnQ5ExDSv6GpXdkx5VS"
        cacheLocation='localstorage'
        authorizationParams={{
          scope: 'openid profile email',
          audience: 'https://sizewall-function-api.azurewebsites.net/',
          redirect_uri: window.location.origin,
        }}
      >
        <Auth0BackedProvider>
          <App />
        </Auth0BackedProvider>
      </Auth0Provider>
    ) : (
      <NoAuthProvider>
        <App />
      </NoAuthProvider>
    )}
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
